export * from "./EndpointsConfig";
export * from "./RegionConfig";